import { useState } from "react";
import { Box, Tab, Tabs, Grid } from "@mui/material";
import TripAudit from "./TripAudit";
import TripB2BActivity from "./TripB2BActivity";
import TripModifications from "./TripModifications";

// Which clients have a parsed inbound B2B feed in RCXcommon.dbo.InboundLog* —
// keep in sync with B2BActivityService.GetB2BActivityPagedAsync. BNSF-Ride
// shares the BNSF InboundLogBNSF feed by ControlNumber. CSX, barge clients etc.
// don't have a feed, so the Railroad Activity tab would always be empty and
// just confuses dispatchers. Hide it on those trips.
const B2B_SUPPORTED_CLIENTS = new Set(["BNSF", "BNSF-RIDE", "UP", "UPRR"]);

const hasRailroadActivity = (clientName?: string) =>
  !!clientName && B2B_SUPPORTED_CLIENTS.has(clientName.trim().toUpperCase());

type ActivityTab = "orderLogs" | "railroadActivity" | "modifications";

// Tabbed wrapper for the bottom-of-details grids: Order Log, Railroad Activity
// (B2B clients only) and Modifications.
const TripActivityTabs = ({ trip }) => {
  const [tab, setTab] = useState<ActivityTab>("orderLogs");
  const showRailroadActivity = hasRailroadActivity(trip?.clientName);
  const activeTab = tab === "railroadActivity" && !showRailroadActivity ? "orderLogs" : tab;

  return (
    <Grid item xs={12}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 1 }}>
        <Tabs value={activeTab} onChange={(_e, v) => setTab(v)}>
          <Tab label="Order Logs" value="orderLogs" />
          {showRailroadActivity && <Tab label="Railroad Activity" value="railroadActivity" />}
          <Tab label="Modifications" value="modifications" />
        </Tabs>
      </Box>
      <Grid container>
        {activeTab === "orderLogs" && <TripAudit trip={trip} />}
        {activeTab === "railroadActivity" && <TripB2BActivity trip={trip} />}
        {activeTab === "modifications" && <TripModifications trip={trip} />}
      </Grid>
    </Grid>
  );
};

export default TripActivityTabs;
